import React, { Component } from "react";
import { Typography, List, ListItem, ListItemText } from "@material-ui/core";

export default class UserList extends Component {
    constructor(props) {
        super(props);
        this.state = { reportNotPresent: false };
    }
    render() {
        const { usersList, currLevel } = this.props;

        return (
            <div
                style={{
                    maxHeight: 550,
                    overflow: "auto",
                }}
            >
                <Typography variant="h6">{currLevel} Users </Typography>
                <List>
                    {usersList &&
                        usersList.map((name) => {
                            return (
                                <ListItem key={name}>
                                    <ListItemText
                                        primary={name ? name : "N/A"}
                                    />
                                </ListItem>
                            );
                        })}
                </List>
            </div>
        );
    }
}
